import { memo, useState } from 'react';
import { BtnAtom, InputAtom, TagAtom } from '../atoms';
import { MAX_CATEGORY_ARRAY_LENGTH } from '../DB/indexedAction';
import styled from '@emotion/styled';
import { TagColorName } from '../styles/emotion';
import { getTagTextColor } from '../atoms/TagAtom';

interface ICategoryInputProps {
  categories: string[] | null;
  category: string;
  handleSubmit: (params: React.KeyboardEvent<HTMLInputElement>) => void;
  handleClick: (category: string) => void;
  handleChangeCategory: (event: React.ChangeEvent<HTMLInputElement>) => void;
  tagColorList: Record<string, TagColorName>;
  isExtreme?: boolean;
}

export const CategoryInput = memo(
  ({
    categories,
    handleSubmit,
    handleClick,
    category,
    handleChangeCategory,
    tagColorList,
    isExtreme,
  }: ICategoryInputProps) => {
    const [isFocus, setIsFocus] = useState(false);
    return (
      <CategoryContainer>
        {categories?.map((category) => (
          <BtnAtom
            handleOnClick={() => handleClick.call(this, category)}
            key={category}
            ariaLabel={`category ${category}`}
            className="category_tag"
          >
            <TagAtom
              styleOption={{
                bg: tagColorList[category],
                size: 'normal',
              }}
              className="tag_with_delete"
              ariaLabel={`category ${category} delete button`}
            >
              {category}
              <svg
                width={'0.875rem'}
                height={'0.875rem'}
                viewBox="0 0 32 32"
                fill={getTagTextColor(tagColorList[category])}
                xmlns="http://www.w3.org/2000/svg"
                aria-label="delete"
              >
                <rect
                  width="1.81331"
                  height="25.3864"
                  transform="matrix(-0.707107 0.707107 0.707107 0.707107 7.28223 6.19336)"
                />
                <rect
                  x="7.28223"
                  y="25.2329"
                  width="1.81331"
                  height="25.3864"
                  transform="rotate(-135 7.28223 25.2329)"
                />
              </svg>
            </TagAtom>
          </BtnAtom>
        ))}
        {categories && categories.length >= MAX_CATEGORY_ARRAY_LENGTH ? null : (
          <label htmlFor="categories">
            <InputAtom.Usual
              value={category}
              id="categories"
              name="categories"
              ariaLabel="category input"
              handleChange={handleChangeCategory}
              handleKeyDown={handleSubmit}
              handleFocus={() => setIsFocus(true)}
              handleBlur={() => setIsFocus(false)}
              placeholder={isFocus ? '태그를 적어주세요' : '태그 추가하기'}
              styleOption={{
                borderStyle: isFocus ? 'solid' : 'dashed',
                borderRadius: '50px',
                borderWidth: '1px',
                textAlign: 'center',
                font: 'body',
                placeholderOpacity: isFocus ? 0.3 : 1,
                placeholderColor: isExtreme ? 'extreme_dark' : 'primary1',
                width: isFocus ? '17ch' : '13ch',
                height: '2rem',
                fontColor: isExtreme ? 'extreme_dark' : 'primary1',
              }}
              tabIndex={0}
            />
          </label>
        )}
      </CategoryContainer>
    );
  },
);

const CategoryContainer = styled.div`
  flex-wrap: wrap;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  @media ${({ theme }) => theme.responsiveDevice.tablet_v},
    ${({ theme }) => theme.responsiveDevice.mobile} {
    input {
      font-size: ${({ theme }) => theme.fontSize.body.size};
    }
  }
  .tag_with_delete {
    padding-right: 0.375rem;
    display: flex;
    gap: 0.375rem;
    padding-left: 0.75rem;
    padding-right: 0.635rem;
  }
`;
